<div
  class="mx-auto w-full max-w-[1280px] flex flex-col pt-8 pb-4 md:pt-12 gap-8 font-sans">
  <!-- Header Section -->
  <div class="text-center space-y-4">
    <div class="flex flex-row items-center justify-center gap-3">
      <div
        class="bg-[#eff6ff] p-2.5 rounded-[14px] flex items-center justify-center">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z"
            stroke="#1e40af"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21"
            stroke="#1e40af"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <h1
        class="font-bold text-2xl min-[360px]:text-3xl min-[425px]:text-4xl text-[#0a0a0a] m-0">
        Bestellung abschliessen
      </h1>
    </div>
    <p class="text-base text-bn-bright max-w-2xl mx-auto">
      Überprüfe deine Angaben sorgfältig und schliesse die Bestellung
      verbindlich ab. Alle Felder mit <span>*</span> sind
      Pflichtfelder.
    </p>
  </div>

  <div class="flex flex-col lg:flex-row gap-6 items-start">
    <!-- Left Column: Billing Details -->
    <div
      class="flex-1 bg-white border border-[rgba(0,0,0,0.08)] rounded-[14px] shadow-[0px_10px_15px_0px_rgba(0,0,0,0.08),0px_4px_6px_0px_rgba(0,0,0,0.05)] overflow-hidden">
      <div class="border-b border-[rgba(0,0,0,0.07)] px-6 py-5">
        <h2 class="text-base font-semibold text-[#111827] m-0">
          Rechnungsinformationen
        </h2>
        <p class="text-sm text-[#6b7280] m-0 mt-1">
          Diese Angaben erscheinen auf deiner Rechnung.
        </p>
      </div>

      <div class="p-6 space-y-6">
        <!-- Organisation Section -->
        <div class="space-y-3">
          <p
            class="text-xs font-semibold text-[#717182] uppercase tracking-wider m-0">
            Organisation
          </p>
          <mat-form-field class="w-full">
            <mat-label>Schule / Organisation</mat-label>
            <input
              matInput
              type="text"
              required
              [(ngModel)]="organizationName"
              placeholder="z. B. Primarschule Zürich Nord" />
            <mat-hint>Name der Schule oder Bildungsinstitution</mat-hint>
          </mat-form-field>
        </div>

        <hr class="border-[rgba(0,0,0,0.07)] m-0" />

        <!-- Kontaktperson Section -->
        <div class="space-y-3">
          <p
            class="text-xs font-semibold text-[#717182] uppercase tracking-wider m-0">
            Kontaktperson
          </p>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4">
            <mat-form-field class="w-full">
              <mat-label>Vorname</mat-label>
              <input
                matInput
                type="text"
                required
                [(ngModel)]="firstName"
                placeholder="z. B. Maria" />
            </mat-form-field>
            <mat-form-field class="w-full">
              <mat-label>Nachname</mat-label>
              <input
                matInput
                type="text"
                required
                [(ngModel)]="lastName"
                placeholder="z. B. Müller" />
            </mat-form-field>
            <mat-form-field class="w-full">
              <mat-label>E-Mail-Adresse</mat-label>
              <input
                matInput
                type="email"
                required
                [(ngModel)]="email"
                placeholder="m.mueller@schule.ch" />
            </mat-form-field>
            <mat-form-field class="w-full">
              <mat-label>Telefonnummer</mat-label>
              <input
                matInput
                type="tel"
                [(ngModel)]="phone"
                placeholder="+41 44 123 45 67" />
            </mat-form-field>
          </div>
        </div>

        <hr class="border-[rgba(0,0,0,0.07)] m-0" />

        <!-- Rechnungsadresse Section -->
        <div class="space-y-3">
          <p
            class="text-xs font-semibold text-[#717182] uppercase tracking-wider m-0">
            Rechnungsadresse
          </p>
          <app-address-autocomplete-field
            [initialZipcode]="zipcode() || undefined"
            [initialCity]="city() || undefined"
            [initialAddress]="street() || undefined"
            (locationResolved)="onLocationResolved($event)"
            (addressComplete)="addressComplete.set($event)" />
          <mat-form-field class="w-full">
            <mat-label>Land</mat-label>
            <mat-select [value]="'CH'" disabled>
              <mat-option value="CH">Schweiz</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <hr class="border-[rgba(0,0,0,0.07)] m-0" />

        <!-- Weitere Angaben Section -->
        <div class="space-y-3">
          <p
            class="text-xs font-semibold text-[#717182] uppercase tracking-wider m-0">
            Weitere Angaben
          </p>
          <mat-form-field class="w-full">
            <mat-label>UID / MwSt-Nummer (optional)</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="taxId"
              placeholder="CHE-123.456.789" />
            <mat-hint
              >Für Unternehmen und Institutionen mit MwSt-Pflicht</mat-hint
            >
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Right Column: Order Summary -->
    <div
      class="w-full lg:w-[400px] bg-white border border-[rgba(0,0,0,0.08)] rounded-[14px] shadow-[0px_10px_15px_0px_rgba(0,0,0,0.08),0px_4px_6px_0px_rgba(0,0,0,0.05)] overflow-hidden sticky top-8">
      <div class="border-b border-[rgba(0,0,0,0.07)] px-6 py-5">
        <h2 class="text-base font-semibold text-[#111827] m-0">
          Bestellübersicht
        </h2>
      </div>

      <div class="p-6 space-y-5">
        @if (!offer()) {
          <!-- Selected Plan -->
          <div class="bg-[#f9fafb] rounded-[10px] px-4 pt-3 pb-3.5">
            <p class="text-sm text-[#717182] m-0 mb-1">Gewählter Plan</p>
            <p class="text-base font-semibold text-[#0a0a0a] m-0">
              Schuleinheit
            </p>
          </div>

          <!-- Laufzeit (Fixed) -->
          <mat-form-field class="w-full">
            <mat-label>Laufzeit</mat-label>
            <mat-select [value]="selectedDuration()" disabled>
              <mat-option [value]="1">1 Jahr</mat-option>
              <mat-option [value]="2">2 Jahre (5% Rabatt)</mat-option>
              <mat-option [value]="3">3 Jahre (10% Rabatt)</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Zusätzliche Admins (Fixed) -->
          <mat-form-field class="w-full">
            <mat-label>Zusätzliche Admins</mat-label>
            <input
              matInput
              type="text"
              disabled
              tabindex="-1"
              [value]="extraAdmins()" />
            <mat-hint>+9.90 CHF / Monat pro Admin</mat-hint>
          </mat-form-field>

          <hr class="border-[rgba(0,0,0,0.07)] m-0" />
        }

        @if (!offer()) {
          <!-- Aktionscode -->
          <div class="space-y-2">
            <div class="flex items-center gap-2">
              <mat-form-field class="flex-1" subscriptSizing="dynamic">
                <mat-label>Aktionscode (optional)</mat-label>
                <mat-icon
                  matPrefix
                  class="material-symbols-rounded text-[#717182]"
                  >confirmation_number</mat-icon
                >
                <input
                  matInput
                  type="text"
                  [(ngModel)]="promotionCode"
                  [readonly]="!!promoInfo()"
                  placeholder="z. B. SCHULE2025" />
              </mat-form-field>
              @if (promoInfo()) {
                <button
                  type="button"
                  mat-flat-button
                  color="warn"
                  (click)="clearPromoCode()"
                  class="bn-promo-action">
                  Entfernen
                </button>
              } @else {
                <button
                  type="button"
                  mat-flat-button
                  color="primary"
                  (click)="onValidatePromo()"
                  [disabled]="validatingPromo() || !promotionCode()"
                  class="bn-promo-action">
                  @if (validatingPromo()) {
                    <mat-spinner diameter="18" />
                  }
                  Einlösen
                </button>
              }
            </div>
            @if (promoInfo(); as promo) {
              <p class="text-sm text-green-600 m-0">
                Code „{{ promo.code }}" angewendet —
                {{ promoDiscountLabelText() }}
              </p>
            }
            @if (promoError()) {
              <p class="text-sm text-red-500 m-0">{{ promoError() }}</p>
            }
          </div>
        }

        <hr class="border-[rgba(0,0,0,0.07)] m-0" />

        <!-- Price Details -->
        @if (offer(); as offer) {
          <div class="space-y-2.5 text-sm" data-testid="offer-summary">
            <div class="flex justify-between items-start">
              <span class="text-[#717182]">{{ offer.label }}</span>
              <span class="text-[#0a0a0a]">
                {{ formatRappenChf(offer.yearly_price_rappen) }} pro Jahr
              </span>
            </div>
            <div class="flex justify-between items-start">
              <span class="text-[#717182]">Mindestlaufzeit</span>
              <span class="text-[#0a0a0a]">
                {{ offer.contract_years }} Jahre ({{
                  offer.contract_start | date: 'dd.MM.yyyy'
                }}
                – {{ offer.contract_end | date: 'dd.MM.yyyy' }})
              </span>
            </div>
            <app-offer-points [points]="offer.customer_notes" />
          </div>

          <hr class="border-[rgba(0,0,0,0.07)] m-0" />

          <div class="flex flex-col gap-1 py-1">
            <div class="flex justify-between items-center">
              <span class="text-base font-semibold text-[#0a0a0a]"
                >Jährlicher Preis</span
              >
              <span class="text-xl font-bold text-[#1e40af]">
                {{ formatRappenChf(offer.yearly_price_rappen) }}
              </span>
            </div>
            <div
              class="flex justify-between items-center text-sm text-[#717182]">
              <span>Danach jährliche Verlängerung zum gleichen Preis</span>
            </div>
          </div>
        } @else {
          <div class="space-y-2.5 text-sm">
            <div class="flex justify-between items-start">
              <span class="text-[#717182]">
                Basispreis ({{ basePricePeriodLabel() }})
              </span>
              <span class="text-[#0a0a0a]">
                {{ formatPrice(basePriceCalculated()) }} CHF
              </span>
            </div>
            @if (extraAdmins() > 0) {
              <div class="flex justify-between items-start">
                <span class="text-[#717182]"
                  >{{ extraAdmins() }} × Admin-Lizenz</span
                >
                <span class="text-[#0a0a0a]">
                  {{ formatPrice(adminsTotal()) }} CHF
                </span>
              </div>
            }
            @if (discountPercent() > 0) {
              <div class="flex justify-between items-start">
                <span class="text-[#00a63e]"
                  >Laufzeitrabatt ({{ discountPercent() }} %)</span
                >
                <span class="text-[#00a63e]">
                  −{{ formatPrice(discountAmount()) }} CHF
                </span>
              </div>
            }
            @if (promoDiscountAmount() > 0) {
              <div class="flex justify-between items-start">
                <span class="text-[#00a63e]">{{
                  promoDiscountLabelText()
                }}</span>
                <span class="text-[#00a63e]">
                  −{{ formatPrice(promoDiscountAmount()) }} CHF
                </span>
              </div>
            }
          </div>

          <hr class="border-[rgba(0,0,0,0.07)] m-0" />

          <!-- Total: the monthly rate leads, the term total follows -- a yearly
               sum as the headline reads like the hurdle, the monthly rate like the
               price. -->
          <div class="flex flex-col gap-1 py-1">
            <div class="flex justify-between items-center">
              <span class="text-base font-semibold text-[#0a0a0a]"
                >Monatlicher Preis</span
              >
              <span class="text-xl font-bold text-[#1e40af]">
                {{ formatPrice(monthlyNetRate()) }} CHF / Monat
              </span>
            </div>
            <div
              class="flex justify-between items-center text-sm text-[#717182]">
              <span>Gesamtbetrag ({{ basePricePeriodLabel() }})</span>
              <span data-testid="checkout-total">
                {{ formatPrice(totalAmount()) }} CHF
              </span>
            </div>
          </div>
        }

        @if (isFirstMonthsFreePromo()) {
          <div class="bg-[#ecfdf5] rounded-[10px] px-4 pt-3 pb-3.5">
            <p class="text-sm font-semibold text-[#0a7d4c] m-0">
              0.00 CHF bis {{ freeUntilDateLabel() }}
            </p>
            <p class="text-sm text-[#0a7d4c] m-0 mt-1">
              Danach regulärer Preis ({{ formatPrice(monthlyNetRate()) }} CHF /
              Monat).
            </p>
          </div>
        }

        <!-- Info Box -->
        <div class="bg-[#eff6ff] rounded-[10px] px-4 pt-3 pb-3.5">
          <p class="text-sm text-[#717182] m-0">
            @if (isFirstMonthsFreePromo()) {
              Sofern du nicht kündigst, wird dir nach Ablauf der kostenlosen
              Phase die Rechnung automatisch zugestellt.
            } @else {
              Nach Abschluss deiner Bestellung erhältst du die Rechnung per
              E-Mail. Das Zahlungsziel beträgt 30 Tage.
            }
          </p>
        </div>

        <hr class="border-[rgba(0,0,0,0.07)] m-0" />

        <!-- Checkbox -->
        <mat-checkbox
          color="primary"
          [checked]="accepted()"
          (change)="accepted.set($event.checked)"
          class="!items-start">
          <span class="text-sm text-[#0a0a0a] leading-[21px]">
            Ich habe die
            <a
              [href]="baseUrl + '/agb'"
              target="_blank"
              rel="noopener"
              (click)="$event.stopPropagation()"
              class="text-[#1e40af] font-medium hover:underline"
              >Allgemeinen Geschäftsbedingungen</a
            >
            und die
            <a
              [href]="baseUrl + '/datenschutz'"
              target="_blank"
              rel="noopener"
              (click)="$event.stopPropagation()"
              class="text-[#1e40af] font-medium hover:underline"
              >Datenschutzerklärung</a
            >
            gelesen und akzeptiere diese.
          </span>
        </mat-checkbox>

        @if (acceptedMissing()) {
          <p class="text-sm text-red-600 m-0">
            Bitte akzeptiere die AGB und die Datenschutzerklärung.
          </p>
        }

        @if (catalogReady() === null) {
          <div
            class="rounded-lg bg-blue-50 p-4 text-sm text-blue-700 border border-blue-100 flex items-center gap-2">
            <mat-spinner diameter="16" strokeWidth="2"></mat-spinner>
            <span>Lizenzkatalog wird geprüft …</span>
          </div>
        } @else if (catalogReady() === false && !error()) {
          <div
            class="rounded-lg bg-red-50 p-4 text-sm text-red-600 border border-red-100">
            Bestellung aktuell nicht möglich. Bitte später erneut versuchen.
          </div>
        }

        @if (error()) {
          <div
            class="rounded-lg bg-red-50 p-4 text-sm text-red-600 border border-red-100">
            {{ error() }}
          </div>
        }

        <!-- Submit Button -->
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="submitting()"
          class="w-full">
          @if (submitting()) {
            <mat-spinner diameter="18" strokeWidth="2" />
          }
          @if (!offer() && (isFirstMonthsFreePromo() || totalAmount() === 0)) {
            Kostenlos starten
          } @else {
            Zahlungspflichtig bestellen
          }
        </button>
      </div>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="flex items-center justify-end gap-4 mt-4">
    <button
      type="button"
      (click)="goBack.emit()"
      [disabled]="submitting()"
      mat-button
      color="primary">
      Zurück
    </button>
  </div>
</div>
